import { render, staticRenderFns } from "./tab6.vue?vue&type=template&id=0de43b0a&scoped=true"
import script from "./tab6.vue?vue&type=script&lang=js"
export * from "./tab6.vue?vue&type=script&lang=js"
import style0 from "./tab6.vue?vue&type=style&index=0&id=0de43b0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de43b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de43b0a')) {
      api.createRecord('0de43b0a', component.options)
    } else {
      api.reload('0de43b0a', component.options)
    }
    module.hot.accept("./tab6.vue?vue&type=template&id=0de43b0a&scoped=true", function () {
      api.rerender('0de43b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab6.vue"
export default component.exports